module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image14-cb57bda7c8944ef8e71b494d09a87afe.jpg";